import { Helmet, HelmetProvider } from 'react-helmet-async'
import { defaultConfig, defaultTheme, defaultThemeB } from 'core/style/theme'
import { deleteCookie } from 'core/singleton'

import App from 'App'
import { ConfigWebLib } from './ConfigWebLib'
import { MODULE_NAME } from 'core/constants'
import Module from 'custom/module'
import React from 'react'
import { RecoilRoot } from 'recoil'
import { RootParams } from 'index'
import { TokenWebLib } from './TokenWebLib'
import { UserTokenInformation } from 'core/api/types'
import { render } from 'react-dom'

export class SauceWebLib {
  id: string
  partnerId: string
  accessToken?: string
  broadcast?: boolean
  broadcastOpenLink?: string
  broadcastTable?: boolean
  curation?: boolean
  curationDetail?: boolean
  schedule?: boolean
  scheduleType?: 'image' | 'feed' | 'list'
  autoPlay?: boolean
  searchBar?: boolean
  sampleTitle?: boolean
  bridge?: boolean
  router?: boolean
  contentBanner?: boolean
  textBanner?: boolean
  memberId?: string
  curationId?: string
  topBanner?: boolean
  domIdList?: {
    id: string
    curationId?: string
    curation?: boolean
    scheduleType?: 'image' | 'feed' | 'list'
    topBanner?: boolean
    calendar?: boolean
    broadcast?: boolean
    searchBar?: boolean
  }[]
  length?: number
  memberType?: string
  sauceClip?: boolean
  renderModuleName?: MODULE_NAME
  configInstance: ConfigWebLib
  tokenInstance: TokenWebLib
  constructor({
    id,
    partnerId,
    broadcast,
    broadcastOpenLink = '',
    broadcastTable,
    curation,
    curationDetail,
    schedule,
    scheduleType,
    autoPlay,
    searchBar,
    sampleTitle,
    bridge,
    router,
    contentBanner,
    textBanner,
    accessToken,
  }: RootParams) {
    this.id = id ?? 'sauce_collect'
    this.partnerId = partnerId ?? ''
    this.broadcast = broadcast
    this.broadcastOpenLink = broadcastOpenLink
    this.broadcastTable = broadcastTable
    this.curation = curation
    this.curationDetail = curationDetail
    this.schedule = schedule
    this.scheduleType = scheduleType
    this.autoPlay = autoPlay
    this.searchBar = searchBar
    this.sampleTitle = sampleTitle
    this.bridge = bridge
    this.router = router
    this.contentBanner = contentBanner
    this.textBanner = textBanner
    this.domIdList = []
    this.configInstance = new ConfigWebLib({ partnerId: this.partnerId })
    this.tokenInstance = new TokenWebLib({ partnerId: this.partnerId, accessToken })
    this.init(accessToken)
  }

  private async init(accessToken?: string) {
    accessToken && this.tokenInstance.setMemberToken(accessToken)
    !accessToken && (await this.tokenInstance.preload())
    !this.configInstance.config && (await this.configInstance.preload())
    if (this.configInstance.config?.guestLogin.use) {
      this.tokenInstance.setParsedLocalData()
    }
  }

  private async renderCuration({ id, curationId }: { id: string; curationId?: string }) {
    try {
      if (!this.partnerId) return
      this.renderModuleName = MODULE_NAME.CURATION
      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      const memberId = this.tokenInstance.getMemberId()
      const memberType = this.tokenInstance.getMemberType()

      await this.configInstance.configPending()

      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }

      render(
        <React.StrictMode>
          <RecoilRoot>
            <Module
              bridge={this.bridge ?? false}
              partnerId={this.partnerId}
              accessToken={originToken ? originToken : accessToken}
              memberType={memberType}
              memberId={memberId}
              broadcast={this.broadcast ?? false}
              curation={this.curation ?? false}
              curationDetail={this.curationDetail ?? true}
              schedule={this.schedule ?? false}
              scheduleType={this.scheduleType ?? 'image'}
              autoPlay={this.autoPlay ?? false}
              router={this.router ?? true}
              searchBar={false}
              sampleTitle={this.sampleTitle ?? false}
              broadcastOpenLink={this.broadcastOpenLink ?? ''}
              theme={this.configInstance?.theme ?? defaultTheme}
              themeB={this.configInstance?.themeB ?? defaultThemeB}
              config={this.configInstance?.config ?? defaultConfig}
              broadcastTable={this.broadcastTable ?? false}
              contentBanner={this.contentBanner ?? false}
              textBanner={this.textBanner ?? false}
              curationId={curationId ?? this.curationId}
              topBanner={this.topBanner ?? false}
              domListLength={this.domIdList?.length ?? 1}
              sauceClip={this.sauceClip ?? false}
              renderModuleName={this.renderModuleName}
            />
          </RecoilRoot>
        </React.StrictMode>,
        document.getElementById(id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  private async renderTopBanner(id: string) {
    try {
      if (!this.partnerId) return
      this.renderModuleName = MODULE_NAME.TOP_BANNER

      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      const memberId = this.tokenInstance.getMemberId()
      const memberType = this.tokenInstance.getMemberType()

      await this.configInstance.configPending()

      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }
      render(
        <React.StrictMode>
          <RecoilRoot>
            <Module
              bridge={this.bridge ?? false}
              partnerId={this.partnerId}
              accessToken={originToken ? originToken : accessToken}
              memberType={memberType}
              memberId={memberId}
              broadcast={this.broadcast ?? false}
              curation={this.curation ?? false}
              curationDetail={this.curationDetail ?? false}
              schedule={this.schedule ?? false}
              scheduleType={this.scheduleType ?? 'image'}
              autoPlay={this.autoPlay ?? false}
              router={this.router ?? true}
              searchBar={false}
              sampleTitle={this.sampleTitle ?? false}
              broadcastOpenLink={this.broadcastOpenLink ?? ''}
              theme={this.configInstance?.theme ?? defaultTheme}
              themeB={this.configInstance?.themeB ?? defaultThemeB}
              config={this.configInstance?.config ?? defaultConfig}
              broadcastTable={this.broadcastTable ?? false}
              contentBanner={this.contentBanner ?? false}
              textBanner={this.textBanner ?? false}
              curationId={this.curationId ?? ''}
              topBanner={this.topBanner ?? true}
              domListLength={this.domIdList?.length ?? 1}
              sauceClip={this.sauceClip ?? false}
              renderModuleName={this.renderModuleName}
            />
          </RecoilRoot>
        </React.StrictMode>,
        document.getElementById(id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  private async renderCalendar(id: string) {
    try {
      if (!this.partnerId) return
      this.renderModuleName = MODULE_NAME.CALENDAR

      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      const memberId = this.tokenInstance.getMemberId()
      const memberType = this.tokenInstance.getMemberType()

      await this.configInstance.configPending()

      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }

      render(
        <React.StrictMode>
          <RecoilRoot>
            <Module
              bridge={this.bridge ?? false}
              partnerId={this.partnerId}
              accessToken={originToken ? originToken : accessToken}
              memberType={memberType}
              memberId={memberId}
              broadcast={this.broadcast ?? false}
              curation={this.curation ?? false}
              curationDetail={this.curationDetail ?? false}
              schedule={this.schedule ?? false}
              scheduleType={this.scheduleType ?? 'image'}
              autoPlay={this.autoPlay ?? false}
              router={this.router ?? true}
              searchBar={false}
              sampleTitle={this.sampleTitle ?? false}
              broadcastOpenLink={this.broadcastOpenLink ?? ''}
              theme={this.configInstance?.theme ?? defaultTheme}
              themeB={this.configInstance?.themeB ?? defaultThemeB}
              config={this.configInstance?.config ?? defaultConfig}
              broadcastTable={this.broadcastTable ?? true}
              contentBanner={this.contentBanner ?? false}
              textBanner={this.textBanner ?? false}
              curationId={this.curationId ?? ''}
              topBanner={this.topBanner ?? false}
              domListLength={this.domIdList?.length ?? 1}
              sauceClip={this.sauceClip ?? false}
              renderModuleName={this.renderModuleName}
            />
          </RecoilRoot>
        </React.StrictMode>,
        document.getElementById(id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  private async renderSchedule({
    id,
    scheduleType,
  }: {
    id: string
    scheduleType?: 'image' | 'feed' | 'list'
  }) {
    try {
      if (!this.partnerId) return
      this.renderModuleName = MODULE_NAME.SCHEDULE

      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      const memberId = this.tokenInstance.getMemberId()
      const memberType = this.tokenInstance.getMemberType()

      await this.configInstance.configPending()

      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }

      render(
        <React.StrictMode>
          <RecoilRoot>
            <Module
              bridge={this.bridge ?? false}
              partnerId={this.partnerId}
              accessToken={originToken ? originToken : accessToken}
              memberType={memberType}
              memberId={memberId}
              broadcast={this.broadcast ?? false}
              curation={this.curation ?? false}
              curationDetail={this.curationDetail ?? false}
              schedule={this.schedule ?? true}
              scheduleType={scheduleType ?? 'image'}
              autoPlay={this.autoPlay ?? false}
              router={this.router ?? true}
              searchBar={false}
              sampleTitle={this.sampleTitle ?? false}
              broadcastOpenLink={this.broadcastOpenLink ?? ''}
              theme={this.configInstance?.theme ?? defaultTheme}
              themeB={this.configInstance?.themeB ?? defaultThemeB}
              config={this.configInstance?.config ?? defaultConfig}
              broadcastTable={this.broadcastTable ?? false}
              contentBanner={this.contentBanner ?? false}
              textBanner={this.textBanner ?? false}
              curationId={this.curationId ?? ''}
              topBanner={this.topBanner ?? false}
              domListLength={this.domIdList?.length ?? 1}
              sauceClip={this.sauceClip ?? false}
              renderModuleName={this.renderModuleName}
            />
          </RecoilRoot>
        </React.StrictMode>,
        document.getElementById(id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  private async renderBroadcast({
    displayType,
    id,
    title,
  }: {
    displayType?: 'horizontal' | 'vertical'
    id: string
    title?: string
  }) {
    try {
      if (!this.partnerId) return

      this.renderModuleName = MODULE_NAME.BROADCAST

      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      const memberId = this.tokenInstance.getMemberId()
      const memberType = this.tokenInstance.getMemberType()

      await this.configInstance.configPending()

      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }

      render(
        <React.StrictMode>
          <RecoilRoot>
            <Module
              bridge={this.bridge ?? false}
              partnerId={this.partnerId}
              accessToken={originToken ? originToken : accessToken}
              memberType={memberType}
              memberId={memberId}
              broadcast={true}
              broadcastDisplayType={displayType}
              broadcastOpenLink={this.broadcastOpenLink ?? ''}
              broadcastTable={this.broadcastTable ?? false}
              broadcastTitle={title}
              curation={this.curation ?? false}
              curationDetail={this.curationDetail ?? false}
              schedule={this.schedule ?? false}
              scheduleType={this.scheduleType ?? 'image'}
              autoPlay={this.autoPlay ?? false}
              router={this.router ?? true}
              searchBar={false}
              sampleTitle={this.sampleTitle ?? false}
              theme={this.configInstance?.theme ?? defaultTheme}
              themeB={this.configInstance?.themeB ?? defaultThemeB}
              config={this.configInstance?.config ?? defaultConfig}
              contentBanner={this.contentBanner ?? false}
              textBanner={this.textBanner ?? false}
              curationId={this.curationId ?? ''}
              topBanner={this.topBanner ?? false}
              domListLength={this.domIdList?.length ?? 1}
              sauceClip={this.sauceClip ?? false}
              renderModuleName={this.renderModuleName}
            />
          </RecoilRoot>
        </React.StrictMode>,
        document.getElementById(id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  async render() {
    try {
      if (!this.partnerId) return
      await this.configInstance.configPending()

      const accessToken = this.tokenInstance.getAccessToken()
      const originToken = this.tokenInstance.getOriginToken()
      if (originToken) {
        await this.tokenInstance.pendingValidation()
      }

      render(
        <React.StrictMode>
          <HelmetProvider>
            <Helmet />
            <RecoilRoot>
              <App
                bridge={this.bridge ?? false}
                partnerId={this.partnerId}
                accessToken={originToken ? originToken : accessToken}
                broadcast={this.broadcast ?? true}
                curation={this.curation ?? true}
                curationDetail={this.curationDetail ?? true}
                schedule={this.schedule ?? true}
                scheduleType={this.scheduleType ?? 'image'}
                autoPlay={this.autoPlay ?? false}
                router={this.router ?? true}
                searchBar={this.searchBar ?? true}
                sampleTitle={this.sampleTitle ?? false}
                broadcastOpenLink={this.broadcastOpenLink ?? ''}
                theme={this.configInstance?.theme ?? defaultTheme}
                themeB={this.configInstance?.themeB ?? defaultThemeB}
                config={this.configInstance?.config ?? defaultConfig}
                broadcastTable={this.broadcastTable ?? false}
                contentBanner={this.contentBanner ?? false}
                textBanner={this.textBanner ?? false}
                curationId={this.curationId ?? ''}
                sauceClip={this.sauceClip ?? false}
                topBanner={this.topBanner ?? true}
              />
            </RecoilRoot>
          </HelmetProvider>
        </React.StrictMode>,
        document.getElementById(this.id ?? 'sauce_collect'),
      )
    } catch (error) {
      console.error('Error initializing SauceWebLib:', error)
    }
  }

  setMemberObject(arg: UserTokenInformation) {
    this.tokenInstance.setMemberObject(arg)
  }
  async setMemberToken(token: string) {
    await this.tokenInstance.setOriginToken(token)
  }

  load(elementId?: string) {
    this.id = elementId ?? 'sauce_collect'
    this.render()
  }

  setLogout() {
    deleteCookie(`collectToken_${this.partnerId}`)
    deleteCookie(`collectMemberId`)
    this.accessToken = 'logout'
  }

  loadCuration({ curationId, elementId }: { curationId: string; elementId?: string }) {
    this.id = elementId ?? 'sauce_collect'
    this.curationId = curationId
    this.domIdList?.push({ id: this.id, curationId: this.curationId })
    this.domIdList?.map(
      async ({ id, curationId }) => curationId && (await this.renderCuration({ id, curationId })),
    )
  }

  loadTopBanner(elementId?: string) {
    this.id = elementId ?? 'sauce_collect'
    this.domIdList?.push({ id: this.id, topBanner: true })
    this.domIdList?.map(async ({ id, topBanner }) => topBanner && (await this.renderTopBanner(id)))
  }

  loadCalendar(elementId?: string) {
    this.id = elementId ?? 'sauce_collect'
    this.domIdList?.push({ id: this.id, calendar: true })
    this.domIdList?.map(async ({ id, calendar }) => calendar && (await this.renderCalendar(id)))
  }

  loadSchedule({
    scheduleType,
    elementId,
  }: {
    scheduleType?: 'image' | 'feed' | 'list'
    elementId?: string
  }) {
    this.id = elementId ?? 'sauce_collect'
    this.scheduleType = scheduleType ?? 'image'
    this.domIdList?.push({ id: this.id, scheduleType: this.scheduleType })
    this.domIdList?.map(
      async ({ id, scheduleType }) =>
        scheduleType && (await this.renderSchedule({ id, scheduleType })),
    )
  }

  loadBroadcast({
    displayType,
    elementId,
    title,
  }: {
    displayType?: 'horizontal' | 'vertical'
    title?: string
    elementId?: string
  }) {
    this.id = elementId ?? 'sauce_collect'
    this.domIdList?.push({ id: this.id, broadcast: true })
    this.domIdList?.map(
      async ({ id, broadcast }) =>
        broadcast && (await this.renderBroadcast({ displayType, id, title })),
    )
  }
}
